<div style="height:100vh;" id="glb-loader" class="loaderShow">
  <img src="./assets/images/svgs/loader.svg"class="loader-img" alt="loader">
</div>

<router-outlet> <app-loader></app-loader></router-outlet>
<simple-notifications></simple-notifications>
